import { useRoutes } from 'react-router-dom';
import { Admin, Cart, Landing, Login, Payment, Shop } from 'features/misc';
import { publicRoutes } from './public';
// import { useAuth } from 'lib/auth';
// import { protectedRoutes } from './protected';

export const AppRoutes = () => {
  // const auth = useAuth();

  const commonRoutes = [
    { path: '/', element: <Landing /> },
    { path: '/shop', element: <Shop /> },
    { path: '/payment', element: <Payment /> },
    { path: '/login', element: <Login /> },
    { path: '/admin', element: <Admin /> },
    { path: '/cart', element: <Cart /> },
  ];

  // const routes = auth.user ? protectedRoutes : publicRoutes;

  const element = useRoutes([...commonRoutes, ...publicRoutes]);

  return <>{element}</>;
};
